// @ts-ignore
import Link from "@gik/core/components/Link.tsx";
import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { SvgIcon } from "@gik/ui-legacy/SvgIcon/SvgIcon";
import ArrowCircleRightIcon from "@heroicons/react/outline/ArrowCircleRightIcon";
import classnames from "classnames";
import type React from "react";

export interface IMarketingNavItemProps
	extends React.HTMLAttributes<HTMLDivElement> {
	href: string;
}

function MarketingNavItemComp({
	children,
	href,
}: IMarketingNavItemProps): React.ReactElement {
	const bem = bemBlock("marketing-nav__item");
	const blockClasses = classnames([bem()]);

	return (
		<li className={blockClasses}>
			<Link href={href}>
				<span className={bem("title")}>{children}</span>
				<div className={bem("icon")}>
					<SvgIcon Icon={ArrowCircleRightIcon} size="lg" />
				</div>
			</Link>
		</li>
	);
}
export const MarketingNavItem =
	withComponentErrorBoundary(MarketingNavItemComp);
